var map = {
	"./featured-title.de-CH.json": 1047,
	"./featured-title.de-DE.json": 1048,
	"./featured-title.en-CA.json": 1049,
	"./featured-title.en-GB.json": 1050,
	"./featured-title.en-IN.json": 1051,
	"./featured-title.en-ME.json": 1052,
	"./featured-title.en-US.json": 1053,
	"./featured-title.es-EM.json": 1054,
	"./featured-title.es-ES.json": 1055,
	"./featured-title.fr-BE.json": 1056,
	"./featured-title.fr-CA.json": 1057,
	"./featured-title.fr-CH.json": 1058,
	"./featured-title.nl-BE.json": 1059,
	"./featured-title.nl-NL.json": 1060,
	"./featured-title.pl-PL.json": 1061,
	"./featured-title.pt-BR.json": 1062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1046;